// extracted by mini-css-extract-plugin
export default {"ErrorContainer":"ErrorPrompt_ErrorContainer__kPeOL"};